import util from 'util'

let sym

if (typeof Symbol !== 'undefined') {
    sym = Symbol.for('nodejs.util.inspect.custom')
}

const isNode = obj => obj && typeof obj === 'object' &&
    (obj.type === 'tag' && 'name' in obj && 'namespace' in obj && 'x-attribsNamespace' in obj) ||
    (obj.type === 'text' && 'data' in obj)

export default function inspect (obj) {
    if (obj && obj.prototype && obj.prototype.cheerio === '[cheerio object]') {
        // cheerio root guy
        return 'CheerioRoot {}'
    }
    if (obj && obj._root && obj._root.constructor &&
        obj._root.constructor.prototype && obj._root.constructor.prototype.cheerio === '[cheerio object]') {
        // cheerio search guy
        return `CheerioSearch { length: ${obj.length} }`
    }
    if (obj && isNode(obj)) {
        let str = `Cheerio${obj.type === 'text' ? 'Text' : ''}Node {`
        if (obj.type === 'tag') {
            str += `
    name: ${JSON.stringify(obj.name)},
    attribs: ${inspect(obj.attribs)},
    children: [Node x${obj.children.length}],`
        } else if (obj.type === 'text') {
            str += `
    data: ${JSON.stringify(obj.data)},`
        }
        str += `
    prev: ${obj.prev ? 'Node' : null},
    next: ${obj.next ? 'Node' : null},
    parent: ${obj.parent ? 'Node' : null}
}`
        return str
    }

    if (obj && Array.isArray(obj) && obj[0] && isNode(obj[0])) {
        obj = '[\n' + obj
            .map(i => inspect(i)
                .split('\n')
                .map(s => '    ' + s)
                .join('\n')
            ).join(',\n') + '\n]'
    }

    if (obj && typeof obj === 'object' && 'toJSON' in obj) {
        obj = obj.toJSON()
    }
    if (obj && sym && obj[sym]) {
        obj = obj[sym]()
    }
    return typeof obj === 'string'
           ? obj || '<empty string>'
           : util.inspect(obj, { compact: false, depth: 2 })
}
